import { render } from "./SecondCut.vue?vue&type=template&id=226b805a&scoped=true"
import script from "./SecondCut.vue?vue&type=script&lang=js"
export * from "./SecondCut.vue?vue&type=script&lang=js"

import "./SecondCut.vue?vue&type=style&index=0&id=226b805a&lang=sass&scoped=true"

import exportComponent from "/Users/liyunchen/Documents/Salute Project/BMW_4GC/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-226b805a"]])

export default __exports__